export default __webpack_public_path__ + "static/media/tw-white.663c5f89.svg";